import { BookingApi, RydeUiUnit, SimpleResult } from "@ryde/shared";

export type CellEditFnMap = Partial<
  Record<
    RydeUiUnit,
    (id: number, data: unknown) => Promise<SimpleResult<unknown>>
  >
>;

export const mapEntityToEditFn: CellEditFnMap = {
  booking: BookingApi.update,
};
